const AppHeaders = {
  Accept: 'accept',
  AcceptLanguage: 'accept-language',
  AcceptVersion: 'accept-version',
  AccessControlAllowCredentials: 'access-control-allow-credentials',
  AccessControlAllowHeaders: 'access-control-allow-headers',
  AccessControlAllowMethods: 'access-control-allow-methods',
  AccessControlAllowOrigin: 'access-control-allow-origin',
  ApiKey: 'x-api-key',
  AuthenticityToken: 'x-authenticity-token',
  BypassMaintenance: 'bypass-maintenance',
  ClientId: 'x-client-id',
  CloudflareIpCountry: 'cf-ipcountry',
  ContentLength: 'content-length',
  ContentMD5: 'content-md5',
  ContentType: 'content-type',
  Cookie: 'cookie',
  CSRFToken: 'X-CSRF-Token',
  Date: 'date',
  ForwardedFor: 'x-forwarded-for',
  IpAddress: 'x-ip-address',
  IpCountry: 'x-ip-country',
  Location: 'location',
  Origin: 'origin',
  Referer: 'referer',
  RequestedWith: 'X-Requested-With',
  SetCookie: 'set-cookie',
  ApiVersion: 'x-api-version',
} as const
type AppHeaders = (typeof AppHeaders)[keyof typeof AppHeaders]
export default AppHeaders
